import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap, Facebook, Instagram, Twitter, Linkedin, Youtube, Mail, MapPin } from 'lucide-react';
import { Button } from '@/components/ui/button';

const LINKS = {
  Explore: [
    { label: 'Colleges', to: '/colleges' },
    { label: 'Universities', to: '/universities' },
    { label: 'Courses', to: '/courses' },
    { label: 'Exams', to: '/exams' },
    { label: 'Blog', to: '/blog' },
  ],
  Streams: [
    { label: 'Engineering', to: '/colleges' },
    { label: 'Management', to: '/colleges' },
    { label: 'Medical', to: '/colleges' },
    { label: 'Law', to: '/colleges' },
    { label: 'Design', to: '/colleges' },
  ],
  Company: [
    { label: 'About Us', to: '#' },
    { label: 'Contact', to: '#' },
    { label: 'Careers', to: '#' },
    { label: 'Advertise', to: '#' },
    { label: 'Privacy Policy', to: '#' },
  ],
};

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300">
      {/* Newsletter */}
      <div className="border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-6 items-center">
          <div>
            <h3 className="text-2xl md:text-3xl font-bold text-white" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              Get admission updates in your inbox
            </h3>
            <p className="text-slate-400 mt-2">Weekly digest of exam dates, cutoffs, application deadlines and scholarship alerts.</p>
          </div>
          <form onSubmit={(e) => e.preventDefault()} className="flex gap-2">
            <input
              type="email"
              required
              placeholder="you@email.com"
              className="flex-1 px-4 py-3 rounded-lg bg-slate-800 border border-slate-700 focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20 outline-none text-white placeholder:text-slate-500"
            />
            <Button type="submit" className="bg-orange-500 hover:bg-orange-600 text-white px-6">Subscribe</Button>
          </form>
        </div>
      </div>

      {/* Main */}
      <div className="max-w-7xl mx-auto px-4 py-12 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2">
          <Link to="/" className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 rounded-lg bg-teal-600 grid place-items-center text-white">
              <GraduationCap className="w-5 h-5" />
            </div>
            <div className="font-bold text-white text-lg" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              Learn<span className="text-teal-400">dunia</span>
            </div>
          </Link>
          <p className="text-sm text-slate-400 mb-4 max-w-sm">
            India&apos;s trusted platform to discover colleges, courses and exams. Compare, review and take the next step in your education journey.
          </p>
          <div className="space-y-2 text-sm text-slate-400">
            <div className="flex items-center gap-2"><Mail className="w-4 h-4" /> hello@learndunia.com</div>
            <div className="flex items-center gap-2"><MapPin className="w-4 h-4" /> Bengaluru, India</div>
          </div>
          <div className="flex items-center gap-2 mt-5">
            {[Facebook, Twitter, Instagram, Linkedin, Youtube].map((Icon, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-full bg-slate-800 hover:bg-teal-600 grid place-items-center transition-colors">
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        {Object.entries(LINKS).map(([title, items]) => (
          <div key={title}>
            <h4 className="text-white font-semibold mb-4" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{title}</h4>
            <ul className="space-y-2 text-sm">
              {items.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-slate-400 hover:text-teal-400 transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Learndunia. All rights reserved.</div>
          <div className="flex gap-4">
            <a href="#" className="hover:text-teal-400">Terms</a>
            <a href="#" className="hover:text-teal-400">Privacy</a>
            <a href="#" className="hover:text-teal-400">Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
